import { Stack, Text } from '@pairy/pds-react';
import cn from 'classnames';
import { SelectField, SelectOption } from '@pairy/sheard/types';

import RequiredMark from '../RequiredMark';
import { FormRecordProps } from '../index.type';

import * as Styled from './index.styles';

interface Props extends FormRecordProps<SelectOption[]> {
  options: SelectField['options'];
  name: string;
  description: string;
  isRequired: boolean;
  range: {
    min: number;
    max: number;
  };
}

const Select = ({
  id,
  options,
  name,
  isRequired,
  description,
  handleChangeWithId,
  translateKoToEn,
  value,
  range,
}: Props) => {
  const { max, min } = range;

  const isBelowMinValue = value?.length < min && Boolean(value);
  const invalidFeedback = `최소 ${min}개 이상 선택해주세요.`;

  const selectedValue = value || [];

  const handleOnClick = (option: SelectOption) => {
    if (selectedValue?.find((v) => v.id === option.id)) {
      handleChangeWithId(
        id,
        selectedValue.filter((v) => v.id !== option.id),
      );
      return;
    }
    if (selectedValue?.length === max) {
      selectedValue.shift();
      handleChangeWithId(id, [...selectedValue, option]);
      return;
    }
    handleChangeWithId(id, [...selectedValue, option]);
  };

  return (
    <Stack gap={8} direction="column" justifyContent="flex-start">
      <Stack gap={4} direction="column">
        <Stack gap={4} alignItems="center">
          <Styled.KeepAllText variant="md-semibold" color="black">
            {name}
          </Styled.KeepAllText>
          {isRequired && <RequiredMark translateKoToEn={translateKoToEn} />}
        </Stack>
        {description && (
          <Styled.KeepAllText as="div" variant="sm-medium" color="zinc_400">
            {description}
          </Styled.KeepAllText>
        )}
      </Stack>
      <Stack gap={8} direction="row" wrap="wrap">
        {options.map((option) => (
          <Styled.SelectButton
            key={option.id}
            className={cn({
              'is-active': selectedValue.find((v) => v.id === option.id),
            })}
            variant="zinc_500"
            radius={9999}
            paddingX={16}
            paddingY={8}
            onClick={() => handleOnClick(option)}
          >
            {option.name}
          </Styled.SelectButton>
        ))}
      </Stack>
      {isBelowMinValue && (
        <Text variant="sm-medium" color="cerise_500">
          {invalidFeedback}
        </Text>
      )}
    </Stack>
  );
};

export default Select;
